/* IMPORT */
import Color from '../color/index.js';
/* MAIN */
const toKeyword = (color) => {
    return Color.format.keyword.stringify(Color.parse(color));
};
/* EXPORT */
export default toKeyword;
